
export enum AgreementType {
    Brand = 1
}
